export const MIN_SCALE = 0.01;

export const CANVAS_CONSTRAINTS_ID = 'CANVAS_CONSTRAINTS_ID';

import { SVGS } from '../shared/icons/constants';
import { CANVAS_ALIGNMENT } from '../../constants';

export const CANVAS_ALIGNMENT_ICONS = {
  [CANVAS_ALIGNMENT.NONE]: SVGS.align,
  [CANVAS_ALIGNMENT.HORIZONTAL_LEFT]: SVGS.alignleft,
  [CANVAS_ALIGNMENT.HORIZONTAL_CENTER]: SVGS.aligncenterhorizontal,
  [CANVAS_ALIGNMENT.HORIZONTAL_RIGHT]: SVGS.alignright,
  [CANVAS_ALIGNMENT.VERTICAL_TOP]: SVGS.aligntop,
  [CANVAS_ALIGNMENT.VERTICAL_TOP_BUFFER]: SVGS.aligntopbuffer,
  [CANVAS_ALIGNMENT.VERTICAL_CENTER]: SVGS.aligncentervertical,
  [CANVAS_ALIGNMENT.VERTICAL_BOTTOM_BUFFER]: SVGS.alignbottombuffer,
  [CANVAS_ALIGNMENT.VERTICAL_BOTTOM]: SVGS.alignbottom,
};

export const LOCKABLE_TRANSFORMS = {
  ROTATION: 'rotation',
  SCALE: 'scale',
  TRANSLATION: 'translation',
};

export const DEFAULT_LOCKED_TRANSFORMS = {
  [LOCKABLE_TRANSFORMS.ROTATION]: true,
  [LOCKABLE_TRANSFORMS.SCALE]: true,
  [LOCKABLE_TRANSFORMS.TRANSLATION]: true,
};
